import { TransactionSuccessToast, ToastDetailRow } from "@/components";
import type { TokenId, TransactionHash } from "@/types";

interface LockSuccessToastProps {
    lockAmount: number;
    lockTokenId: TokenId;
    transactionHash: TransactionHash;
    onClose?: () => void;
}

export function LockSuccessToast({ lockAmount, lockTokenId, transactionHash, onClose }: LockSuccessToastProps) {
    return (
        <TransactionSuccessToast title="Lock successful" transactionHash={transactionHash} onClose={onClose}>
            <ToastDetailRow label="Locked" amount={lockAmount} tokenId={lockTokenId} />
        </TransactionSuccessToast>
    );
}
